import { AlertCircle, CheckCircle2, Info } from "lucide-react";

import { useToast } from "@/application/hooks/use-toast";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/presentation/components/shared/ui/toast";
import { cn } from "@/shared/utils/cn";

const VARIANT_ICON = {
  default: {
    Icon: Info,
    wrapperClass: "bg-primary/10",
    iconClass: "text-primary",
  },
  destructive: {
    Icon: AlertCircle,
    wrapperClass: "bg-destructive/10",
    iconClass: "text-destructive",
  },
  success: {
    Icon: CheckCircle2,
    wrapperClass: "bg-emerald-50",
    iconClass: "text-emerald-600",
  },
} as const;

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider label="Notifications">
      {toasts.map(function ({
        id,
        title,
        description,
        action,
        variant,
        ...props
      }) {
        const { Icon, iconClass, wrapperClass } =
          VARIANT_ICON[variant ?? "default"];
        return (
          <Toast
            key={id}
            variant={variant}
            role={variant === "destructive" ? "alert" : "status"}
            {...props}
          >
            <span
              className={cn(
                "flex h-9 w-9 shrink-0 items-center justify-center rounded-lg",
                wrapperClass,
              )}
              aria-hidden="true"
            >
              <Icon className={cn("h-4 w-4", iconClass)} />
            </span>
            <div className="min-w-0 flex-1 self-center">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
